import { render, staticRenderFns } from "./setEmail.vue?vue&type=template&id=f54f2e94&scoped=true"
import script from "./setEmail.vue?vue&type=script&lang=js"
export * from "./setEmail.vue?vue&type=script&lang=js"
import style0 from "./setEmail.vue?vue&type=style&index=0&id=f54f2e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54f2e94",
  null
  
)

export default component.exports